<template>
  <b-modal size="lg" ref="disclaimer-minor-modal" no-close-on-backdrop no-close-on-esc>
    <template #modal-header>
      <h5> EDITH-Nutzung nicht möglich</h5>
    </template>
    <b-container id="modal-container">EDITH darf nicht für minderjährige Patienten verwendet werden.</b-container>
    <template #modal-footer>
      <b-button @click="$emit('patientIsMinor')" variant="outline-danger">
        <b-icon-arrow-left-circle/> Zurück zur Patientenliste
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "DisclaimerForMinorPatient",
  props: {
    show: Boolean
  },
  emits: {
    patientIsMinor: null
  },
  mounted() {
    if (this.show) {
      this.$refs["disclaimer-minor-modal"].show()
    } else {
      this.$refs["disclaimer-minor-modal"].hide()
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newVal) {
      this.$refs["disclaimer-minor-modal"].toggle()
    }
  }
}
</script>

<style scoped>
#modal-container {
  padding-top: 100px;
  padding-bottom: 100px;
}
</style>